import { useBreakpoints } from '@procsea/design-system'

import { usePersona } from './usePersona'
import { useSegment } from './useSegment'
import {
  TrackCtaArgs,
  TrackFilterArgs,
  TrackFormFieldArgs,
  TrackingType,
  UseTrackingArgs,
  UseTrackingResult,
  breakpointMapper,
  filterNameMapper,
} from './useTracking.types'

export const useTracking = ({ persona, source }: UseTrackingArgs): UseTrackingResult => {
  const { track } = useSegment()
  const { activeBreakpoint } = useBreakpoints()
  const activePersona = usePersona()

  const breakpoint = breakpointMapper[activeBreakpoint]

  const trackFilter = (payload: TrackFilterArgs) =>
    track(TrackingType.FILTER, {
      breakpoint,
      persona: persona ?? activePersona,
      source,
      ...payload,
      filterName: filterNameMapper[payload.filterName] ?? payload.filterName,
      filterValue: payload.filterValue === undefined ? null : payload.filterValue,
    })

  const trackCta = (payload: TrackCtaArgs) =>
    track(
      TrackingType.CTA,

      {
        breakpoint,
        persona: persona ?? activePersona,
        source,
        ...payload,
      }
    )

  const trackFormField = (payload: TrackFormFieldArgs) =>
    track(TrackingType.FORM_FIELD, {
      breakpoint,
      persona: persona ?? activePersona,
      source,
      ...payload,
    })

  return { trackCta, trackFilter, trackFormField }
}
